'use client'

import Link from 'next/link'
import {usePathname} from 'next/navigation'
import {useTranslations} from 'next-intl'
import {PRIMARY_NAV} from './nav'

/**
 * Primary navigation below 720px (T-WEB-08).
 *
 * `aria-current="page"` rather than a class alone: the active tab has to be
 * announceable, not only visible, and colour is never the sole carrier
 * (T-A11Y-01).
 */
export function BottomNav({locale}: {locale: string}) {
  const t = useTranslations('shell')
  const pathname = usePathname()

  return (
    <nav className="u-app__tabs" aria-label={t('primaryNav')}>
      {PRIMARY_NAV.map(({href, key, Icon}) => {
        const target = `/${locale}${href}`
        const active = pathname === target || pathname.startsWith(`${target}/`)
        return (
          <Link
            key={key}
            href={target}
            className="u-app__tab"
            aria-current={active ? 'page' : undefined}
          >
            <Icon aria-hidden="true" strokeWidth={active ? 2.4 : 1.8} />
            <span>{t(key)}</span>
          </Link>
        )
      })}
    </nav>
  )
}
